import {ButtonBase} from '@mui/material';
import Grid from '@mui/material/Grid2';
import {styled} from '@mui/system';
import PropTypes from 'prop-types';
import React from 'react';

const ButtonBaseComponent = styled(ButtonBase)({
  width: '100%',
  paddingTop: '100%',
  position: 'relative',
});

const windowOptions = {
  width: 600,
  height: 400,
};

const ShareButton = ({
  icon,
  query,
  url,
  name,
  trackEvent,
  href,
  onClick,
  color,
  iconColor,
  ...otherProps
}) => {
  const handleClick = () => {
    const queryString = new URLSearchParams(query).toString();

    const pairs = [];
    for (const key in windowOptions) {
      pairs.push(`${key}=${windowOptions[key]}`);
    }
    window.open(`${url}?${queryString}`, 'share', pairs.join(','));
    trackEvent(`${name} button clicked`);
  };

  const Icon = React.cloneElement(icon, {
    sx: {
      width: '30%',
      height: '30%',
      fill: theme => iconColor || theme.palette.common.white,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      ...icon.sx,
    },
  });

  return (
    <Grid size={4}>
      <ButtonBaseComponent
        component={href ? 'a' : 'button'}
        href={href}
        onClick={href ? null : onClick || handleClick}
        style={{backgroundColor: color}}
        {...otherProps}
      >
        {Icon}
      </ButtonBaseComponent>
    </Grid>
  );
};

ShareButton.propTypes = {
  color: PropTypes.string.isRequired,
  href: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  iconColor: PropTypes.string,
  name: PropTypes.string,
  onClick: PropTypes.func,
  url: PropTypes.string,
  query: PropTypes.object,
  trackEvent: PropTypes.func,
  dataCy: PropTypes.string,
};

export default ShareButton;
